import {
  doublePrecision,
  jsonb,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid
} from 'drizzle-orm/pg-core';

export const jobModalityEnum = pgEnum('job_modality', ['text', 'voice']);

import { atsProviderEnum } from './ats-configs';
import { departments } from './departments';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';
import { users } from './users';

export const jobs = pgTable(
  'jobs',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    departmentId: uuid('department_id')
      .notNull()
      .references(() => departments.id),
    title: text('title').notNull(),
    description: text('description'),
    employer: text('employer'),
    location: text('location'),
    latitude: doublePrecision('latitude'),
    longitude: doublePrecision('longitude'),
    modality: jobModalityEnum('modality').array().notNull().default([]),
    languages: text('languages').array().notNull().default([]),
    setupStatus: text('setup_status', {
      enum: ['draft', 'questions_pending', 'ready', 'active']
    })
      .notNull()
      .default('draft'),
    atsExternalJobId: text('ats_external_job_id'),
    atsProvider: atsProviderEnum('ats_provider'),
    atsStageIds: jsonb('ats_stage_ids').$type<{
      initialStage: string;
      passInterviewStage: string;
      failInterviewStage: string;
      recommendedStage: string;
    } | null>(),
    atsUserId: text('ats_user_id'),
    atsExternalData: jsonb('ats_external_data').$type<Record<string, unknown> | null>(),
    applicantSyncStatus: text('applicant_sync_status', {
      enum: ['pending', 'syncing', 'synced', 'failed']
    }),
    lastApplicantSyncAt: timestamp('last_applicant_sync_at', { withTimezone: true }),
    recommendedPushedAt: timestamp('recommended_pushed_at', { withTimezone: true }),
    status: text('status', { enum: ['active', 'archived'] })
      .notNull()
      .default('active'),
    createdById: uuid('created_by_id')
      .notNull()
      .references(() => users.id),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp('updated_at', { withTimezone: true })
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  () => [tenantOrgIsolationPolicy()]
).enableRLS();
